import { render } from "./menu3.vue?vue&type=template&id=48da1c05"
import script from "./menu3.vue?vue&type=script&lang=ts"
export * from "./menu3.vue?vue&type=script&lang=ts"
script.render = render

export default script